export const PRODUCT_IMAGE_ASPECT_RATIO = '4 / 5';
export const PRODUCT_IMAGE_OBJECT_FIT = 'contain';
export const PRODUCT_IMAGE_BACKGROUND = '#ffffff';
